import React, {Component} from 'react';
import HistoryContext from "./HistoryContext";
import axios from "axios";
import {host} from "../utils/constants";
import ApiAutoCaller from "../utils/ApiAutoCaller";

const period = 'day';

class HistoryProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.autoCallers = {};
        this.token = this.props.token;
    }

    start(serial) {
        if (serial in this.autoCallers) {
            return
        }

        const apiAutoCaller = new ApiAutoCaller(
            this.fetch.bind(this, serial),
            this.handleHistory.bind(this, serial),
            120000,
            30000
        );
        apiAutoCaller.start();
        this.autoCallers[serial] = apiAutoCaller;
    }

    fetch(serial) {
        if (!serial || this.state[serial]) {
            return;
        }

        const to = new Date();
        const from = new Date();
        from.setHours(to.getHours() - 6);

        return axios.get(`${host}/public/history/${serial}?period=${period}&from=${from.toISOString()}&to=${to.toISOString()}`, {
            headers: {
                'Authorization': `Bearer ${this.token}`
            },
        })
    }

    handleHistory(serial, data) {
        if (data['statusCode']) {
            console.log(data)
        }

        data = data.map(x => ([
            new Date(x._id.timestamp),
            x.value.iaq[1]
        ]));
        this.setState({
            [serial]: data
        })
    }

    render() {
        return (
            <HistoryContext.Provider value={{
                start: this.start.bind(this),
                state: this.state
            }}>
                {this.props.children}
            </HistoryContext.Provider>
        );
    }
}

HistoryProvider.propTypes = {};

export default HistoryProvider;
